import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import AutomotiveIcon from "../../../assets/ProductShot/icons/API-Automotive.svg";
import LifestyleIcon from "../../../assets/ProductShot/icons/API-Lifestyle.svg";
import copyApiImage from "../../../assets/ProductShot/images/product-shot-overview.png";
import DemoIcon from "../../../assets/common/icons/demo.svg";
import ConsoleOverviewCards, { OverviewCardType } from "../../../components/Home/Overview/Cards/ConsoleOverviewCards";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import RouterConstants from "../../../constants/RouterConstants";

const ProductShotOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "productShot.overview" });
	const cards: OverviewCardType[] = [
		{
			icon: LifestyleIcon,
			title: t("cards.lifestyle.title"),
			description: t("cards.lifestyle.description"),
			link: RouterConstants.PRODUCT_SHOT.API.fullPath,
		},
		{
			icon: AutomotiveIcon,
			title: t("cards.automotive.title"),
			description: t("cards.automotive.description"),
			link: `${RouterConstants.PRODUCT_SHOT.API.fullPath}#automotive`,
		},
		{
			icon: DemoIcon,
			title: t("cards.demo.title"),
			description: t("cards.demo.description"),
			link: RouterConstants.PRODUCT_SHOT.DEMO.fullPath,
		},
	];

	return (
		<ConsoleOverviewLayout
			copyApiTokenProps={{
				image: copyApiImage,
				description: t("copyApiToken.description"),
			}}
			integrations={["COMFY_UI", "FAL"]}
		>
			<ConsoleOverviewCards cards={cards} />
		</ConsoleOverviewLayout>
	);
};

export default observer(ProductShotOverview);
